import React from "react";
import PropTypes from "prop-types";
import "./ChatTab.css";

/**
 * ChatTab component that provides a notice about the GraphQL chat interface
 * and a button to navigate to it.
 */
const ChatTab = ({ onNavigateToGraphQLChats }) => {
  return (
    <div className="chat-management">
      <div className="chat-management-container">
        <div className="notice-box">
          <h3>Chat Management Upgraded</h3>
          <p>
            We've moved to a new and improved chat management system using
            GraphQL.
          </p>
          <button className="primary-btn" onClick={onNavigateToGraphQLChats}>
            Go to New Chat Interface
          </button>
        </div>
      </div>
    </div>
  );
};

ChatTab.propTypes = {
  onNavigateToGraphQLChats: PropTypes.func.isRequired,
};

export default ChatTab;
